import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { NavRibbon, NavRibbonLink } from '../../../../components/nav-ribbon/NavRibbon';
import { PageContent, PageHeading } from '../../../../components/page-components/_index';
import { DataSettingsScene } from './DataSettings';
import { NotificationSettingsScene } from './NotificationSettings';

export const UserPreferences = () => {
    
        return <PageContent pageName={ 'test' }>
                <PageHeading title="Preferences" />

                    <NavRibbon links={[
                        new NavRibbonLink(
                            `/support/users/preferences/notifications`, 
                            'la-bell',
                            'Notifications',
                            []
                        ),
                        new NavRibbonLink(
                            `/support/users/preferences/data`, 
                            'la-database',
                            'Storage',
                            []
                        )
                    ]} />

                    <Switch>

                        <Route
                            key="prefs-notification"
                            exact={true}
                            path="/support/users/preferences/notifications"
                            render={() => <NotificationSettingsScene />}
                        />
                        <Route
                            key="prefs-data"
                            exact={true}
                            path="/support/users/preferences/data"
                            render={() => <DataSettingsScene />}
                        />

                        <Redirect
                            key="prefs-redirect"
                            exact={true}
                            from="/support/users/preferences"
                            to={ '/support/users/preferences/notifications' } />

                    </Switch>
                    
            </PageContent>; 
    
};
